import { DOCUMENT, Location, PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit, Optional, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiNewsService } from '@core/services/api/api-news.service';
import { ButtonHandlerService } from '@core/services/button-handler.service';

import { ClientService } from '@core/services/client/client.service';
import { GlobalService } from '@core/services/common/global.service';
import { StyleService } from '@core/services/common/styles/style.service';
import { ListComponent } from '@modules/creator/components/special-block/list/list.component';
import { LoaderService } from '@modules/loaders/services/loader.service';
import { FiltersService } from '@shared/services/filters/filters.service';
import { LocalStorageService, SessionStorageService } from '@shared/services/storage';

@Component({
    selector: 'app-news-list',
    templateUrl: '../list/list.component.html',
    styleUrls: ['../list/list.component.scss'],
    standalone: false,
    // AT-9245: stan filtrów należy do tej jednej listy, tak jak w pozostałych listach.
    // Na instancji aplikacyjnej `filtersTo` (BehaviorSubject) przechowuje ostatnią akcję
    // filtrów przez całą sesję, więc lista utworzona po powrocie z podglądu dostawała ją
    // natychmiast po subskrypcji i nawigowała routerem, wycierając z adresu numer strony.
    providers: [FiltersService]
})
export class NewsListComponent extends ListComponent implements OnInit {

  constructor(
    styleService: StyleService,
    clientService: ClientService,
    apiService: ApiNewsService,
    buttonHandlerService: ButtonHandlerService,
    location: Location,
    platformLocation: PlatformLocation,
    route: ActivatedRoute,
    router: Router,
    localStorageService: LocalStorageService,
    storageService: SessionStorageService,
    renderer: Renderer2,
    loaderService: LoaderService,
    globalService: GlobalService,
    @Optional() filtersService: FiltersService,
    @Inject(PLATFORM_ID) platformId: any,
    @Inject(DOCUMENT) document: Document
  ) {
    super(
      styleService,
      clientService,
      apiService,
      buttonHandlerService,
      location,
      platformLocation,
      route,
      router,
      localStorageService,
      storageService,
      renderer,
      loaderService,
      globalService,
      platformId,
      document,
      filtersService,
    );
  }
}
